// request.js ===> axios的二次封装
// export const baseUrl = {
//     // baseURL: 'http://124.70.8.231:8088'
//     // baseURL: 'http://192.168.10.116:8088'
// }

// 1. 引入axios
import axios from 'axios'
// import { ElMessage, ElMessageBox } from 'element-plus'
// // setToken, getToken, removeToken
// import { getToken, removeToken } from '@/utils/token'
// import { userStoreInStore } from '@/store/modules/user'
import { baseUrl } from './base'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 2. 创建 - axios 实例
const service = axios.create({
    baseURL: baseUrl.urlOnline,
    timeout: 20000
})

// 3. 添加请求拦截器
service.interceptors.request.use(function (config) {
    // console.log("请求拦截器",config);
    // 在发送请求之前做些什么 === 》判断用户是否是登录状态
    // if (config.headers.isToken) {
    //     config.headers['token-cookie'] = getToken()
    // }
    return config
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
})

// 4. 添加响应拦截器
service.interceptors.response.use(function (response) {
    // console.log("response", response.request.responseType)
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    // console.log("response", response);
    // const code = response.data.code * 1;
    // const msg = response.data.message;
    return Promise.resolve(response)

    if (code == 1 || code == 2 || code == 3) {
        ElMessage.error(msg)// 直接错误提示
        return Promise.reject(msg)
    } else if (code === 200) {
        // return Promise.resolve(response.data.data.result || response.data)
        return Promise.resolve(response.data)
    } else if (code * 1 > 10 && code * 1 < 16) {
        // 500 - 用户未登录 -  msg: "登录已过期"
        // ElMessage.error(msg);// 直接错误提示
        // ElMessage({
        //   message: msg,
        //   type: 'error'
        // })
        let noticeMessage = "";
        switch (code) {
            case 11:
                noticeMessage = "当前用户未登录"
                break;
            case 12:
                noticeMessage = "登录已过期"
                break;
            case 13:
                noticeMessage = "当前登录token无效"
                break;
            case 14:
                noticeMessage = "您的账号已在其他设备登录"
                break;
            case 15:
                noticeMessage = "您的账号被超管强制下线"
                break;
        }
        ElMessageBox.confirm(noticeMessage, '系统提示', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
        }).then((ok) => {
            console.log("点击确定", ok)// ok =confirm
            // 点击重新登录
            // userStoreInStore().loginOut()
            removeToken();
            location.href = "/login";
        }).catch((cancel) => {
            console.log('点击取消', cancel)// cancel=cancel
        })
        return Promise.reject(msg)
    } else if (response.request.responseType == 'blob') {
        return Promise.resolve(response.data)
    }

    // return "666"
}, function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error)
})

export default service
